// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__38UtZ","text":"SelectPayment_text__3_Fsc","title":"SelectPayment_title___Xx0T","btn":"SelectPayment_btn__fteHe"};